// import React, { useState, useEffect, useRef } from "react";
// import {
//   Row,
//   Col,
//   Card,
//   CardBody,
//   Button,
//   Spinner,
//   Alert,
//   Badge
// } from "reactstrap";
// import { useNavigate, useLocation } from "react-router-dom";
// import { toast } from "react-toastify";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
// // import "./RefundReceipt.css"; // Optional: You can keep styles in separate CSS file

// const RefundReceipt = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const receiptRef = useRef(null);
//   document.title = "Technical Hub | Refund Receipt";

//   const [receiptData, setReceiptData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [downloading, setDownloading] = useState(false);
//   const [printLoading, setPrintLoading] = useState(false);

//   useEffect(() => {
//     if (location.state && location.state.receiptData) {
//       setReceiptData(location.state.receiptData);
//       setLoading(false);
//     } else {
//       toast.error("No receipt data found");
//       navigate("/refunds-list");
//     }
//   }, [location, navigate]);

//   // Format date
//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-IN', {
//       day: '2-digit',
//       month: '2-digit',
//       year: 'numeric'
//     });
//   };

//   // Format date with time for receipt details
//   const formatDateTime = (dateString) => {
//     if (!dateString) return 'N/A';
//     const date = new Date(dateString);
//     return date.toLocaleString('en-IN', {
//       day: '2-digit',
//       month: '2-digit',
//       year: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: true
//     });
//   };

//   // Generate PDF with better quality
//   const generatePDF = async () => {
//     try {
//       setDownloading(true);

//       const element = receiptRef.current;
//       if (!element) {
//         throw new Error("Receipt element not found");
//       }

//       // Create a clone of the element for PDF generation
//       const clone = element.cloneNode(true);
//       clone.style.width = "210mm";
//       clone.style.height = "297mm";
//       clone.style.padding = "0";
//       clone.style.margin = "0";
//       document.body.appendChild(clone);

//       const canvas = await html2canvas(clone, {
//         scale: 3, // Higher scale for better quality
//         useCORS: true,
//         logging: false,
//         backgroundColor: '#ffffff',
//         allowTaint: false,
//         removeContainer: true,
//         width: clone.scrollWidth,
//         height: clone.scrollHeight,
//         windowWidth: clone.scrollWidth,
//         windowHeight: clone.scrollHeight
//       });

//       document.body.removeChild(clone);

//       const imgData = canvas.toDataURL('image/jpeg', 1.0);
//       const pdf = new jsPDF({
//         orientation: 'portrait',
//         unit: 'mm',
//         format: 'a4'
//       });

//       const pdfWidth = pdf.internal.pageSize.getWidth();
//       const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

//       pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);
//       pdf.save(`refund-receipt-${receiptData.roll_no}-${Date.now()}.pdf`);

//       toast.success("Receipt downloaded successfully!");
//     } catch (error) {
//       console.error("Error generating PDF:", error);
//       toast.error("Failed to download receipt");
//     } finally {
//       setDownloading(false);
//     }
//   };

//   // Print receipt with better handling
//   const handlePrint = () => {
//     setPrintLoading(true);

//     const printContent = document.getElementById('printable-receipt').innerHTML;
//     const originalContent = document.body.innerHTML;

//     const printWindow = window.open('', '_blank', 'width=800,height=600');

//     printWindow.document.write(`
//       <!DOCTYPE html>
//       <html>
//         <head>
//           <title>Refund Receipt - ${receiptData.roll_no}</title>
//           <style>
//             @media print {
//               @page {
//                 margin: 0;
//                 size: A4 portrait;
//               }
//               body {
//                 margin: 0;
//                 padding: 0;
//                 -webkit-print-color-adjust: exact;
//                 print-color-adjust: exact;
//               }
//             }
//             * {
//               margin: 0;
//               padding: 0;
//               box-sizing: border-box;
//             }
//             body {
//               font-family: 'Arial', sans-serif;
//               background: white;
//               display: flex;
//               justify-content: center;
//               align-items: center;
//               min-height: 100vh;
//             }
//             .receipt-print-container {
//               width: 210mm;
//               height: 297mm;
//               position: relative;
//               background: white;
//               border: 1px solid #ddd;
//             }
//             .receipt-background {
//               position: absolute;
//               top: 0;
//               left: 0;
//               width: 100%;
//               height: 100%;
//               background-image: url('${window.location.origin}/PaymentRefund.png');
//               background-size: contain;
//               background-repeat: no-repeat;
//               background-position: center;
//               opacity: 1;
//               z-index: 1;
//             }
//             .receipt-content {
//               position: relative;
//               z-index: 2;
//               width: 100%;
//               height: 100%;
//             }
//             .receipt-section {
//               position: absolute;
//               width: 100%;
//             }
//             .receipt-section.original {
//               top: 0;
//               height: 50%;
//             }
//             .receipt-section.duplicate {
//               top: 50%;
//               height: 50%;
//             }
//             .field-group {
//               position: absolute;
//               display: flex;
//               flex-direction: column;
//             }
//             .field-label {
//               font-size: 12px;
//               color: #666;
//               margin-bottom: 2px;
//             }
//             .field-value {
//               font-size: 16px;
//               font-weight: bold;
//               color: #000;
//             }
//             /* Original Copy Fields */
//             .original .payment-id { top: 8%; left: 66%; }
//             .original .payment-date { top: 10%; left: 66%; }
//             .original .student-name { top: 17.3%; left: 9.9%; }
//             .original .roll-no { top: 22.5%; left: 9.9%; }
//             .original .technology { top: 22.5%; left: 28.4%; }
//             .original .college { top: 22.5%; left: 40%; }
//             .original .passout-year { top: 22.5%; left: 55%; }
//             .original .track-name { top: 29.5%; left: 9.9%; }
//             .original .course-name { top: 29.5%; left: 40%; }
//             .original .amount { top: 35.1%; left: 11.5%; }
//             .original .term { top: 35.1%; left: 40.3%; }

//             /* Duplicate Copy Fields */
//             .duplicate .payment-id { top: 8%; left: 66%; }
//             .duplicate .payment-date { top: 10%; left: 66%; }
//             .duplicate .student-name { top: 17.3%; left: 9.9%; }
//             .duplicate .roll-no { top: 22.5%; left: 9.9%; }
//             .duplicate .technology { top: 22.5%; left: 28.4%; }
//             .duplicate .college { top: 22.5%; left: 40%; }
//             .duplicate .passout-year { top: 22.5%; left: 55%; }
//             .duplicate .track-name { top: 29.5%; left: 9.9%; }
//             .duplicate .course-name { top: 29.5%; left: 40%; }
//             .duplicate .amount { top: 35.1%; left: 11.5%; }
//             .duplicate .term { top: 35.1%; left: 40.3%; }
//           </style>
//         </head>
//         <body>
//           <div class="receipt-print-container">
//             <div class="receipt-background"></div>
//             <div class="receipt-content">
//               ${printContent}
//             </div>
//           </div>
//           <script>
//             window.onload = function() {
//               window.focus();
//               setTimeout(() => {
//                 window.print();
//                 setTimeout(() => {
//                   window.close();
//                 }, 1000);
//               }, 500);
//             };
//           </script>
//         </body>
//       </html>
//     `);

//     printWindow.document.close();
//     setPrintLoading(false);
//   };

//   if (loading) {
//     return (
//       <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
//         <Spinner color="primary" />
//         <span className="ms-2">Loading receipt...</span>
//       </div>
//     );
//   }

//   if (!receiptData) {
//     return null;
//   }

//   return (
//     <React.Fragment>
//       <Row>
//         <Col xl="12">
//           <Card className="border-0 shadow-sm">
//             <CardBody className="p-4">
//               {/* Header Section */}
//               <div className="d-flex justify-content-between align-items-center mb-4 no-print">
//                 <div>
//                   <h4 className="card-title mb-1 text-primary">
//                     <i className="bx bx-receipt me-2"></i>
//                     Refund Receipt
//                   </h4>
//                   <p className="text-muted mb-0">
//                     Receipt for {receiptData.student_name} ({receiptData.roll_no})
//                   </p>
//                 </div>
//                 {/* <Badge color="success" className="fs-6 px-3 py-2">
//                   <i className="bx bx-check-shield me-1"></i>
//                   Refund Processed
//                 </Badge> */}
//               </div>

//               {/* Action Buttons */}
//               <div className="d-flex justify-content-between align-items-center mb-4 no-print">
//                 <div className="d-flex gap-2">
//                   <Button
//                     color="primary"
//                     onClick={handlePrint}
//                     disabled={printLoading}
//                     className="px-4 py-2"
//                   >
//                     {printLoading ? (
//                       <>
//                         <Spinner size="sm" className="me-2" />
//                         Preparing...
//                       </>
//                     ) : (
//                       <>
//                         <i className="bx bx-printer me-2"></i>
//                         Print Receipt
//                       </>
//                     )}
//                   </Button>
//                   <Button
//                     color="success"
//                     onClick={generatePDF}
//                     disabled={downloading}
//                     className="px-4 py-2"
//                   >
//                     {downloading ? (
//                       <>
//                         <Spinner size="sm" className="me-2" />
//                         Generating PDF...
//                       </>
//                     ) : (
//                       <>
//                         <i className="bx bx-download me-2"></i>
//                         Download PDF
//                       </>
//                     )}
//                   </Button>
//                 </div>
//                 <Button
//                   color="outline-secondary"
//                   onClick={() => navigate("/refund-approval-list")}
//                   className="px-4 py-2"
//                 >
//                   <i className="bx bx-arrow-back me-2"></i>
//                   Back to Refunds
//                 </Button>
//               </div>

//               {/* Receipt Preview */}
//               <div className="receipt-preview-container mb-4 no-print">
//                 <div className="d-flex justify-content-between align-items-center mb-3">
//                   <h6 className="text-muted mb-0">Receipt Preview</h6>
//                   <small className="text-muted">Scroll to see both copies</small>
//                 </div>
//                 <div
//                   className="receipt-wrapper border rounded-3 bg-white"
//                   style={{ maxHeight: '600px', overflowY: 'auto' }}
//                 >
//                   <div
//                     ref={receiptRef}
//                     id="printable-receipt"
//                     className="receipt-container mx-auto"
//                     style={{ width: '210mm', height: '297mm', position: 'relative' }}
//                   >
//                     {/* Background Image */}
//                     <div
//                       className="receipt-background"
//                       style={{
//                         position: 'absolute',
//                         top: 0,
//                         left: 0,
//                         width: '100%',
//                         height: '100%',
//                         backgroundImage: 'url("/PaymentRefund.png")',
//                         backgroundSize: 'contain',
//                         backgroundRepeat: 'no-repeat',
//                         backgroundPosition: 'center',
//                         opacity: 1,
//                         zIndex: 1
//                       }}
//                     ></div>

//                     {/* Original Copy */}
//                     <div className="receipt-section original" style={{ position: 'absolute', top: 0, height: '50%', width: '100%', zIndex: 2 }}>
//                       <div className="field-group" style={{ top: '18%', left: '75%' }}>
//                         <div className="field-value" style={{ fontSize: '15px', fontWeight: 'bold' }}>
//                           {receiptData.payment_id}
//                         </div>
//                       </div>

//                       <div className="field-group" style={{ top: '35%', left: '7.9%' }}>
//                         <div className="field-value" style={{ fontSize: '20px', fontWeight: 'bold' }}>
//                           {receiptData.name || 'N/A'}
//                         </div>
//                       </div>
//                       <div className="field-group" style={{ top: '45%', left: '8%' }}>
//                         <div className="field-value" style={{ fontSize: '18px', fontWeight: 'bold' }}>
//                           {receiptData.roll_no}
//                         </div>
//                       </div>
//                       <div className="field-group" style={{ top: '45%', left: '28.4%' }}>
//                         <div className="field-value" style={{ fontSize: '18px', fontWeight: 'bold' }}>
//                           {receiptData.branch || 'N/A'}
//                         </div>
//                       </div>
//                       <div className="field-group" style={{ top: '45%', left: '42%' }}>
//                         <div className="field-value" style={{ fontSize: '18px', fontWeight: 'bold' }}>
//                           {receiptData.college || 'N/A'}
//                         </div>
//                       </div>
//                       <div className="field-group" style={{ top: '45%', left: '58%' }}>
//                         <div className="field-value" style={{ fontSize: '18px', fontWeight: 'bold' }}>
//                           {receiptData.passout_year || 'N/A'}
//                         </div>
//                         <div className="field-group" style={{ top: '10%', left: '350%' }}>
//                         <div className="field-value" style={{ fontSize: '18px', fontWeight: 'bold' }}>
//                           {formatDate(receiptData.payment_date)}
//                         </div>
//                       </div>
//                       </div>
//                       <div className="field-group" style={{ top: '59%', left: '42%' }}>
//                         <div className="field-value" style={{ fontSize: '20px', fontWeight: 'bold' }}>
//                           {receiptData.technology_name || 'N/A'}
//                         </div>
//                       </div>

//                       <div className="field-group" style={{ top: '59%', left: '8%' }}>
//                         <div className="field-value" style={{ fontSize: '20px', fontWeight: 'bold' }}>
//                           {receiptData.course_name || 'N/A'}
//                         </div>
//                       </div>
//                       <div className="field-group" style={{ top: '69%', left: '10.5%' }}>
//                         <div className="field-value" style={{ fontSize: '20px', fontWeight: 'bold', color: '#000' }}>
//                           {receiptData.refund_amount}
//                         </div>
//                       </div>
//                       <div className="field-group" style={{ top: '68.5%', left: '41.3%' }}>
//                         <div className="field-value" style={{ fontSize: '20px', fontWeight: 'bold' }}>
//                           {receiptData.term || 'N/A'}
//                         </div>
//                       </div>
//                     </div>

//                     {/* Duplicate Copy */}
//                     <div className="receipt-section duplicate" style={{ position: 'absolute', top: '50%', height: '50%', width: '100%', zIndex: 2 }}>
//                       <div className="field-group" style={{ top: '18%', left: '75%' }}>
//                         <div className="field-value" style={{ fontSize: '15px', fontWeight: 'bold' }}>
//                           {receiptData.payment_id}
//                         </div>
//                       </div>
//                       <div className="field-group" style={{ top: '45%', left: '76.5%' }}>
//                         <div className="field-value" style={{ fontSize: '18px', fontWeight: 'bold' }}>
//                           {formatDate(receiptData.payment_date)}
//                         </div>
//                       </div>
//                       <div className="field-group" style={{ top: '35%', left: '8%' }}>
//                         <div className="field-value" style={{ fontSize: '18px', fontWeight: 'bold' }}>
//                           {receiptData.name || 'N/A'}
//                         </div>
//                       </div>
//                       <div className="field-group" style={{ top: '45%', left: '8%' }}>
//                         <div className="field-value" style={{ fontSize: '18px', fontWeight: 'bold' }}>
//                           {receiptData.roll_no}
//                         </div>
//                       </div>
//                       <div className="field-group" style={{ top: '45%', left: '28.4%' }}>
//                         <div className="field-value" style={{ fontSize: '18px', fontWeight: 'bold' }}>
//                           {receiptData.branch || 'N/A'}
//                         </div>
//                       </div>
//                       <div className="field-group" style={{ top: '45%', left: '42%' }}>
//                         <div className="field-value" style={{ fontSize: '18px', fontWeight: 'bold' }}>
//                           {receiptData.college || 'N/A'}
//                         </div>
//                       </div>
//                       <div className="field-group" style={{ top: '45%', left: '58%' }}>
//                         <div className="field-value" style={{ fontSize: '18px', fontWeight: 'bold' }}>
//                           {receiptData.passout_year || 'N/A'}
//                         </div>
//                       </div>
//                       <div className="field-group" style={{ top: '58.5%', left: '41%' }}>
//                         <div className="field-value" style={{ fontSize: '18px', fontWeight: 'bold' }}>
//                           {receiptData.technology_name || 'N/A'}
//                         </div>
//                       </div>
//                       <div className="field-group" style={{ top: '58.5%', left: '8.5%' }}>
//                         <div className="field-value" style={{ fontSize: '20px', fontWeight: 'bold' }}>
//                           {receiptData.course_name || 'N/A'}
//                         </div>
//                       </div>
//                       <div className="field-group" style={{ top: '69%', left: '10%' }}>
//                         <div className="field-value" style={{ fontSize: '20px', fontWeight: 'bold', color: '#000' }}>
//                           {receiptData.refund_amount}
//                         </div>
//                       </div>
//                       <div className="field-group" style={{ top: '69%', left: '41.5%' }}>
//                         <div className="field-value" style={{ fontSize: '20px', fontWeight: 'bold' }}>
//                           {receiptData.term || 'N/A'}
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Receipt Details Summary */}


//               {/* Success Alert */}
//               {/* <Alert color="success" className="mt-4 text-center no-print">
//                 <i className="bx bx-check-circle me-2 fs-4"></i>
//                 <strong>Refund processed successfully!</strong> Amount refunded: ₹{receiptData.refund_amount}
//               </Alert> */}
//             </CardBody>
//           </Card>
//         </Col>
//       </Row>

//       <style>
//         {`
//           .no-print {
//             display: block;
//           }
//           @media print {
//             .no-print {
//               display: none !important;
//             }
//           }
//           .receipt-preview-container {
//             background: #f8f9fa;
//             padding: 20px;
//             border-radius: 10px;
//           }
//           .receipt-wrapper {
//             box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
//             background: white;
//           }
//           .field-group {
//             position: absolute;
//           }
//           .field-value {
//             font-family: 'Arial', sans-serif;
//           }
//         `}
//       </style>
//     </React.Fragment>
//   );
// };

// export default RefundReceipt;

import React, { useState, useEffect } from "react";
import {
  Row, Col, Card, CardBody, Button, Spinner,
} from "reactstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "./RefundInvoice.css";

const RefundReceipt = () => {
  const navigate = useNavigate();
  const location = useLocation();
  document.title = "Technical Hub | Refund Receipt";

  const [receiptData, setReceiptData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    setUser(authUser);
  }, []);

  useEffect(() => {
    if (location.state?.receiptData) {
      setReceiptData(location.state.receiptData);
      setLoading(false);
    } else {
      toast.error("No receipt data found");
      navigate("/refunds-list");
    }
  }, [location, navigate]);

  // Format date to IST — same as payment invoice
  const formatDate = (isoDate) => {
    if (!isoDate) return "N/A";
    return new Date(isoDate).toLocaleDateString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).replaceAll("/", "-");
  };


  // Shrink cashier name to single line — same as payment invoice
  const fitSingleLine = (invoiceDiv, selector) => {
    const el = invoiceDiv.querySelector(selector);
    if (!el) return;

    el.style.transform = "none";
    el.style.whiteSpace = "nowrap";

    const clone = el.cloneNode(true);
    clone.style.position = "fixed";
    clone.style.visibility = "hidden";
    clone.style.left = "0";
    clone.style.top = "0";
    clone.style.width = "auto";
    clone.style.whiteSpace = "nowrap";
    document.body.appendChild(clone);

    const textWidth = clone.scrollWidth;
    document.body.removeChild(clone);

    const maxWidth = invoiceDiv.offsetWidth * 0.22;
    if (textWidth > maxWidth && maxWidth > 0) {
      const scale = maxWidth / textWidth;
      el.style.transform = `scaleX(${scale})`;
      el.style.transformOrigin = "left center";
    }
  };

  // Generate PDF — exact same off-screen pattern as payment invoice
  const generatePDF = async () => {
    if (!receiptData) return;
    setDownloading(true);

    return new Promise(async (resolve) => {
      const {
        payment_id,
        payment_date,
        name,
        roll_no,
        branch,
        college,
        passout_year,
        course_name,
        technology_name,
        refund_amount,
        term,
      } = receiptData;

      const cashier_name = user?.first_name || "";        // ← from localStorage
      const formattedDate = formatDate(payment_date);

      // Build hidden div — exact same approach as payment invoice
      const invoiceDiv = document.createElement("div");
      invoiceDiv.className = "refund-container";
      invoiceDiv.style.position = "absolute";
      invoiceDiv.style.left = "-9999px";

      invoiceDiv.innerHTML = `
        <div class="refund-overlay">

          <!-- ORIGINAL COPY -->
          <h1 class="r-payment-id">No.${payment_id}</h1>
          <h1 class="r-payment-date">${formattedDate}</h1>
          <h2 class="r-name">${name || "N/A"}</h2>
          <h2 class="r-roll-no">${roll_no || "N/A"}</h2>
          <h2 class="r-branch">${branch || "N/A"}</h2>
          <h2 class="r-college">${college || "N/A"}</h2>
          <h2 class="r-passout">${passout_year || "N/A"}</h2>
          <h2 class="r-course">${course_name || "N/A"}</h2>
          <h2 class="r-technology">${technology_name || "N/A"}</h2>
          <h2 class="r-amount">${refund_amount || "N/A"}</h2>
          <h2 class="r-term">${term || "N/A"}</h2>
          <h2 class="r-cashier">${cashier_name || ""}</h2>

          <!-- DUPLICATE COPY -->
          <h1 class="r-payment-id-1">No.${payment_id}</h1>
          <h1 class="r-payment-date-1">${formattedDate}</h1>
          <h2 class="r-name-1">${name || "N/A"}</h2>
          <h2 class="r-roll-no-1">${roll_no || "N/A"}</h2>
          <h2 class="r-branch-1">${branch || "N/A"}</h2>
          <h2 class="r-college-1">${college || "N/A"}</h2>
          <h2 class="r-passout-1">${passout_year || "N/A"}</h2>
          <h2 class="r-course-1">${course_name || "N/A"}</h2>
          <h2 class="r-technology-1">${technology_name || "N/A"}</h2>
          <h2 class="r-amount-1">${refund_amount || "N/A"}</h2>
          <h2 class="r-term-1">${term || "N/A"}</h2>
          <h2 class="r-cashier-1">${cashier_name || ""}</h2>

        </div>
      `;

      document.body.appendChild(invoiceDiv);

      // Shrink cashier name to single line — same as payment invoice
      fitSingleLine(invoiceDiv, ".r-cashier");
      fitSingleLine(invoiceDiv, ".r-cashier-1");

      try {
        const canvas = await html2canvas(invoiceDiv, { scale: 2, useCORS: true });
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const imgHeight = (canvas.height * pageWidth) / canvas.width;
        pdf.addImage(imgData, "PNG", 0, 0, pageWidth, imgHeight);

        // Open in new tab — same as payment invoice
        const pdfBlob = pdf.output("blob");
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, "_blank");

        toast.success("Receipt generated successfully!");
      } catch (err) {
        console.error("PDF generation error:", err);
        toast.error("Failed to generate receipt");
      } finally {
        document.body.removeChild(invoiceDiv);
        setDownloading(false);
        setTimeout(() => resolve(), 200);
      }
    });
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
        <Spinner color="primary" />
        <span className="ms-2">Loading receipt...</span>
      </div>
    );
  }

  if (!receiptData) return null;

  const formattedDate = formatDate(receiptData.payment_date);
  return (
    <React.Fragment>
      <Row>
        <Col xl="12">
          <Card className="border-0 shadow-sm">
            <CardBody className="p-4">

              {/* Header */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                  <h4 className="card-title mb-1 text-primary">
                    <i className="bx bx-receipt me-2"></i>Refund Receipt
                  </h4>
                  <p className="text-muted mb-0">
                    Receipt for {receiptData.name} ({receiptData.roll_no})
                  </p>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <Button
                  color="success"
                  onClick={generatePDF}
                  disabled={downloading}
                  className="px-4 py-2"
                >
                  {downloading ? (
                    <><Spinner size="sm" className="me-2" />Generating...</>
                  ) : (
                    <><i className="bx bx-download me-2"></i>Download / View PDF</>
                  )}
                </Button>

                <Button
                  color="outline-secondary"
                  onClick={() => navigate("/refund-approval-list")}
                  className="px-4 py-2"
                >
                  <i className="bx bx-arrow-back me-2"></i>Back to Refunds
                </Button>
              </div>

              {/* Receipt Preview — mirrors the off-screen div layout */}
              <div style={{ background: "#f8f9fa", padding: "20px", borderRadius: "10px" }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="text-muted mb-0">Receipt Preview</h6>
                  <small className="text-muted">Scroll to see both copies</small>
                </div>
                <div className="border rounded-3 bg-white" style={{ maxHeight: "700px", overflowY: "auto" }}>
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      maxWidth: "1200px",
                      aspectRatio: "8.5 / 11",
                      backgroundImage: 'url("/PaymentRefund.png")',
                      backgroundSize: "contain",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      margin: "0 auto",
                    }}
                  >
                    <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}>

                      {/* ORIGINAL COPY */}
                      <h1 className="r-payment-id">No.{receiptData.payment_id}</h1>
                      <h1 className="r-payment-date">{formattedDate}</h1>
                      <h2 className="r-name">{receiptData.name || "N/A"}</h2>
                      <h2 className="r-roll-no">{receiptData.roll_no || "N/A"}</h2>
                      <h2 className="r-branch">{receiptData.branch || "N/A"}</h2>
                      <h2 className="r-college">{receiptData.college || "N/A"}</h2>
                      <h2 className="r-passout">{receiptData.passout_year || "N/A"}</h2>
                      <h2 className="r-course">{receiptData.course_name || "N/A"}</h2>
                      <h2 className="r-technology">{receiptData.technology_name || "N/A"}</h2>
                      <h2 className="r-amount">{receiptData.refund_amount || "N/A"}</h2>
                      <h2 className="r-term">{receiptData.term || "N/A"}</h2>
                      <h2 className="r-cashier">{user?.first_name || ""}</h2>

                      {/* DUPLICATE COPY */}
                      <h1 className="r-payment-id-1">No.{receiptData.payment_id}</h1>
                      <h1 className="r-payment-date-1">{formattedDate}</h1>
                      <h2 className="r-name-1">{receiptData.name || "N/A"}</h2>
                      <h2 className="r-roll-no-1">{receiptData.roll_no || "N/A"}</h2>
                      <h2 className="r-branch-1">{receiptData.branch || "N/A"}</h2>
                      <h2 className="r-college-1">{receiptData.college || "N/A"}</h2>
                      <h2 className="r-passout-1">{receiptData.passout_year || "N/A"}</h2>
                      <h2 className="r-course-1">{receiptData.course_name || "N/A"}</h2>
                      <h2 className="r-technology-1">{receiptData.technology_name || "N/A"}</h2>
                      <h2 className="r-amount-1">{receiptData.refund_amount || "N/A"}</h2>
                      <h2 className="r-term-1">{receiptData.term || "N/A"}</h2>
                      <h2 className="r-cashier-1">{user?.first_name || ""}</h2>

                    </div>
                  </div>
                </div>
              </div>

            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default RefundReceipt;